import ConsentForm from 'react-components/consent-form/consent-form';
import { Consent } from 'state/consent/types';
import styles from './jit-consent-modal.module.scss';

type Props = {
  payload: {
    consent: Consent;
    onConsentSuccess: () => void;
  };
};

export const JitConsentModal = (props: Props) => {
  const { consent, onConsentSuccess } = props.payload;

  return (
    <div className={styles.modal}>
      <ConsentForm
        consent={consent}
        goForward={onConsentSuccess}
        submitButtonText={polyglot.t('components.consent.submit_button')}
      />
    </div>
  );
};
